import { ContentCopy } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { useAppDispatch } from '../../../Store/Hooks'
import { showAlert } from '../../../Store/Slice/alert.slice'

export const TooltipText = ({ text, length = 25 }: { text: string; length: number }) => {
  const dispatch = useAppDispatch()

  const truncatedValue = () => {
    return `${text.slice(0, length)}${text.length >= length ? '...' : ''}`
  }

  const copyToClipboard = (event: any) => {
    if (event?.stopPropagation) event.stopPropagation()
    navigator.clipboard.writeText(text)
    dispatch(showAlert([true, 'Text copied in clipboard.', 'success']))
  }

  return text.length > length ? (
    <Tooltip
      disableInteractive={false}
      title={
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <div
            style={{ width: '86%' }}
            onClick={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
            onMouseDown={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
            onMouseUp={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
          >
            {text}
          </div>
          {truncatedValue() !== '' && (
            <div style={{ textAlign: 'center' }}>
              <button
                onClick={copyToClipboard}
                style={{
                  padding: '4px',
                  fontSize: '8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginLeft: '8px',
                  border: 'none',
                }}
                onMouseUp={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
                onMouseDown={(e) => (e?.stopPropagation ? e.stopPropagation() : '')}
              >
                <ContentCopy sx={{ color: '#402080', height: '16px' }} />
              </button>
            </div>
          )}
        </div>
      }
      arrow
    >
      <span data-testid='truncated'>{truncatedValue()}</span>
    </Tooltip>
  ) : (
    <span>{text}</span>
  )
}
